<template>
  <li v-if="status !== 'not-available'">
    <!-- idle: show activate button -->
    <button v-if="status === 'idle'" class="dropdown-item" @click="subscribe">
      <i class="fa-solid fa-bell nav-icon"></i>
      Benachrichtigungen aktivieren
    </button>

    <!-- subscribed: show active + deactivate button -->
    <span
      v-else-if="status === 'subscribed'"
      class="dropdown-item d-flex align-items-center justify-content-between gap-2"
    >
      <span><i class="fa-solid fa-bell-on nav-icon"></i> Benachrichtigungen aktiv</span>
      <button class="btn btn-sm btn-outline-secondary" @click="unsubscribe">Deaktivieren</button>
    </span>

    <!-- loading: spinner -->
    <span v-else-if="status === 'loading'" class="dropdown-item text-muted">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Bitte warten…
    </span>

    <!-- denied: recovery instructions -->
    <span v-else-if="status === 'denied'" class="dropdown-item">
      <i class="fa-solid fa-bell-slash nav-icon text-warning"></i>
      <strong>Push blockiert.</strong>
      <br />
      <small
        >Zum Reaktivieren: Browser-Einstellungen → Datenschutz/Benachrichtigungen → diese Seite →
        Erlauben, dann Seite neu laden.</small
      >
    </span>

    <!-- needs-install: iOS install gate -->
    <span v-else-if="status === 'needs-install'" class="dropdown-item">
      <i class="fa-solid fa-mobile-screen-button nav-icon"></i>
      Push-Benachrichtigungen erfordern die installierte App.
      <br />
      <small>Tippe unten auf „Teilen" → „Zum Home-Bildschirm", dann neu öffnen.</small>
    </span>
  </li>
</template>

<script setup>
import { onMounted } from 'vue';
import { usePushNotifications } from '@/composables/usePushNotifications';

const { status, checkExistingSubscription, subscribe, unsubscribe } = usePushNotifications();
onMounted(checkExistingSubscription);
</script>
